import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { SenecScreenTemplate } from "../SenecScreenTemplate";

export const RegistrationLoading = () => {
    const { t } = useTranslation();

    return <SenecScreenTemplate content={<Typography>{t("registrationScreenRegistrationInProgress")}</Typography>} />;
};
